import { VersionRange } from '../../models/core/version-range.js';
import { DataModelBuilder, isSameData, SerializationContext, SerializedData } from '../../models/dto/dto.js';
import { LocalizedString } from '../../models/serializable/localized-string.js';
import { MapUtils } from '../../utility/map-utils.js';
import { Component } from '../core/component.js';

export class TitleComponent extends Component {
  static readonly TYPE_ID: string = '9a49dacf042143f8832db0092041ff7f';
  static readonly SCHEMA_VERSION: number = 1;

  constructor(
    public readonly title: LocalizedString,
  ) {
    super();
  }

  get $typeId(): string {
    return TitleComponent.TYPE_ID;
  }

  get $removable(): boolean {
    return true;
  }

  get $schemaVersion(): VersionRange {
    return VersionRange.exactly(TitleComponent.SCHEMA_VERSION);
  }

  static fromMap(context: SerializationContext, map: SerializedData): TitleComponent {
    return new TitleComponent(
        context.fromData<LocalizedString>(MapUtils.getRaw(map, 'title') as SerializedData),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'title': context.toData(this.title),
    };
  }

  clone(): this {
    return new TitleComponent(
        this.title.clone(),
    ) as this;
  }

  isSame(other: TitleComponent): boolean {
    if(this === other) {
      return true;
    }

    return isSameData(other.title, this.title);
  }
}

export class TitleComponentBuilder extends DataModelBuilder<TitleComponent> {
  build(context: SerializationContext, map: SerializedData): TitleComponent {
    return TitleComponent.fromMap(context, map);
  }
}
